import React from 'react'
import { useNavigate } from "react-router-dom";
import "./CustomStatus.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { get_platform_bg_color } from '../../script/util';
import successGif from '../../images/success.gif';
import { useStateFields } from "../../store/hooks";


const CustomStatus = ({errorMessage, successMessage, redirectBtn, redirectURL, actionButton, action, messageSubtitle=null}) => {
    const navigate = useNavigate();
    const { blocked } = useStateFields(['blocked']);

    return (
      <div className="error-container">
        <div className="error-box" style={{backgroundColor: get_platform_bg_color()}}>
          {errorMessage && (
            <>
                <div className='error-gif'>
                  <img src={"https://assets.graphia.in/site_media/react/error.webp"} alt="error" />
                </div>
                <h2 className="error-title">Oops! Something went wrong.</h2>
                <p className="error-message">{errorMessage}.</p>
                {!blocked && <button
                  onClick={() => navigate((redirectBtn && redirectURL) ? redirectURL : "/dashboard")}
                  className="error-button"
                >
                  <FontAwesomeIcon icon={faArrowLeft} size='lg' style={{color: "#000000",}} />
                  <span>Go to {(redirectBtn && redirectURL) ? redirectBtn : "Dashboard"}</span>
                </button>}
            </>
          )}
          {successMessage && (
            <>
              <div className='error-gif'>
                <img src={successGif} alt="success" style={{'borderRadius': '50%'}}/>
              </div>
              <p className="error-message">{successMessage}.</p>
              <p className="error-title">{messageSubtitle}</p>
              {actionButton && (
                <button
                  onClick={action}
                  className="error-button"
                >
                  <FontAwesomeIcon icon={faArrowLeft} size='lg' style={{color: "#000000",}} />
                  <span>{actionButton}</span>
                </button>
              )}
            </>
          )}
        </div>
      </div>
    );
}

export default CustomStatus;